import type { ReactNode } from 'react';
import { cn } from '@/utils/cn';

export interface InfoCell {
  label: string;
  value: ReactNode;
}

/** Karte mit Eckdaten im 2-Spalten-Raster („Welt & Server" – Minecraft und Steam). */
export const InfoGridCard = ({ icon, title, cells, action }: { icon: ReactNode; title: string; cells: InfoCell[]; action?: ReactNode }) => (
  <div className="bg-surface border border-line rounded-2xl overflow-hidden">
    <div className="flex items-center justify-between gap-2 px-5 py-3.5 border-b border-line">
      <div className="flex items-center gap-2 text-sm font-medium text-fg">
        {icon} {title}
      </div>
      {action}
    </div>
    <div className="grid grid-cols-2 gap-px bg-white/[0.06]">
      {cells.map(({ label, value }, i) => (
        <div
          key={label}
          className={cn('bg-surface px-5 py-3.5 min-w-0', i === cells.length - 1 && cells.length % 2 === 1 && 'col-span-2')}
        >
          <div className="text-[10px] uppercase tracking-[0.08em] font-medium text-fg-muted">{label}</div>
          <div className="mt-1 text-sm text-fg truncate">{value}</div>
        </div>
      ))}
    </div>
  </div>
);

/** „Bearbeiten →"-Link in der Kartenkopfzeile. */
export const CardLink = ({ onClick, children }: { onClick: () => void; children: ReactNode }) => (
  <button onClick={onClick} className="text-xs font-medium text-ember hover:text-ember-2 transition-colors inline-flex items-center gap-1">
    {children}
  </button>
);
